import React, { FC } from 'react'

import { BlogPostConfig, GhostPost } from '../../../utils/types'
import Link from '../../common/Link/Link'
import styles from './GuideHeader.module.scss'

type Props = {
  post: GhostPost
  postConfig: BlogPostConfig
}

const GuideHeaderText: FC<Props> = ({ post, postConfig }) => {
  const { head_config } = post
  const { isSIG, isSSG } = postConfig

  if (!head_config) {
    return null
  }

  return (
    <>
      {head_config.description
        ?.split('\n')
        .map((text) => <p key={text} className={styles.description} dangerouslySetInnerHTML={{ __html: text }} />) ||
        null}
      {isSSG && (
        <div className='kg-callout-card'>
          <div>💡</div>
          <p>
            Create a unique song structure with ease, try out free{' '}
            <span>ChordChord Song Structure Template Generator</span>.
          </p>
        </div>
      )}
      {isSIG && (
        <div className='kg-callout-card'>
          <div>💡</div>
          <p>
            If you’re looking for instant inspiration for your song idea, try out free{' '}
            <span>ChordChord Song Ideas Generator</span>.
          </p>
        </div>
      )}
      <div className='link-to-chapter'>
        <div className='icon link-to-guide-songwriting-icon'></div>
        <div>
          <p>This is Chapter {head_config.chapterNum} in the</p>
          <Link href={head_config.guideLink}>{head_config.guideName}</Link>
        </div>
      </div>
    </>
  )
}

export default GuideHeaderText
